export default {
  "content": "<path fill=\"#fff\" fill-rule=\"evenodd\" d=\"M2 6h12L8 18 2 6zm18 36h12l-6 12-6-12z\" clip-rule=\"evenodd\" opacity=\".2\"/>",
  "attrs": {
    "xmlns": "http://www.w3.org/2000/svg",
    "width": "36",
    "height": "72",
    "fill": "none",
    "viewBox": "0 0 36 72"
  }
};